import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router'
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import { Icon } from 'antd';

import * as actionCreators from '../../actions/auth';
import { deleteCookie } from '../../cookies/';
import { COOKIE_KEY, AUTH_INFO_KEY } from '../../config/session';

const storage = window.localStorage;

@connect(
  state => ({ auth: state.get('Auth') }),
  dispatch => bindActionCreators(actionCreators, dispatch)
)
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false
    };
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }
  logout = () => {
    const { logout } = this.props;
    logout()
      .then(() => {
        deleteCookie(COOKIE_KEY);
        storage.removeItem(AUTH_INFO_KEY);
        browserHistory.push('/pages/login');
      });
  }

  render() {
    const user = JSON.parse(storage.getItem(AUTH_INFO_KEY));
    return (
      <header className="app-header navbar">
        <button className="navbar-toggler mobile-sidebar-toggler hidden-lg-up" onClick={this.mobileSidebarToggle} type="button">&#9776;</button>
        <a className="navbar-brand" >{''}</a>
        <ul className="nav navbar-nav hidden-md-down">
          <li className="nav-item">
            <a className="nav-link navbar-toggler sidebar-toggler" href="#sidebar-toggler" onClick={this.sidebarToggle} >&#9776;</a>
          </li>
        </ul>
        <ul className="nav navbar-nav ml-auto">
          <li className="nav-item">
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
              <a href="#customer-info" onClick={this.toggle} className="nav-link dropdown-toggle nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
                <img src={require('../../../public/img/avatars/3.jpg')} className="img-avatar" alt="admin@bootstrapmaster.com" />
                <span className="hidden-md-down">{user && user.name}</span>
              </a>
              <DropdownMenu className="dropdown-menu-right">
                <DropdownItem onClick={this.logout}><Icon type="logout" />退出</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </li>
        </ul>
      </header>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./components/Header/index.js